import React, { ForwardRefExoticComponent } from 'react'
import { useTransition, animated, config } from 'react-spring'
import styled, { CSSProperties } from 'styled-components'

import {
  ImageContainer,
  StyledResponsiveImage,
  Title,
  Content,
  Length,
  StyledLink,
} from './Insight.styles'
import { DiscoverItemFragment } from '@sketch/gql-types'

const AnimatedSection = animated.section as ForwardRefExoticComponent<{
  children: React.ReactElement
  style: CSSProperties
  className?: string
  'data-testid': string
}>

type InsightProps = Pick<
  DiscoverItemFragment,
  'id' | 'image' | 'title' | 'source' | 'length' | 'url'
> & {
  className?: string
  onItemClick?: React.MouseEventHandler
  imageRef?: React.Ref<HTMLDivElement>
}

const BaseInsight = ({
  id,
  image,
  title,
  source,
  length,
  url,
  onItemClick,
  imageRef,
  className,
}: InsightProps) => {
  const transitions = useTransition(id, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: config.slow,
  })

  return (
    <>
      {transitions.map(
        ({ item, key, props }) =>
          item && (
            <AnimatedSection
              className={className}
              data-testid="insight-item"
              key={key}
              style={props}
            >
              <StyledLink
                href={url!}
                rel="noreferrer"
                target="_blank"
                external
                onClick={onItemClick}
              >
                <ImageContainer ref={imageRef}>
                  <StyledResponsiveImage image={image!} withSkeletonUI />
                  {length && <Length>▶ {length}</Length>}
                </ImageContainer>
                <Title>{title}</Title>
                <Content>{source}</Content>
              </StyledLink>
            </AnimatedSection>
          )
      )}
    </>
  )
}

export const Insight = styled(BaseInsight)``
